import Global from "@/scripts/Global";
import VueSignals from '@/scripts/VueSignals'

export default {
    name: 'LeaveChannel',
    data() {
        return {
            currData: {
                'channel_name': '',
                'channel_id': ''
            },
            confirmCheck: false,
        }
    },
    mounted() {
        this.currData = this.$parent.data
    },
    methods: {
        deleteFF() {
            if (this.confirmCheck) {
                Global.globalValue(VueSignals.LEAVE_CHANNEL_CONFIRMATION, this.currData.channel_id)
            }
        }
    }
}
